import { render, staticRenderFns } from "./labe.vue?vue&type=template&id=0becbc27"
import script from "./labe.vue?vue&type=script&lang=js"
export * from "./labe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports